var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"GoogleMap"},[_c('div',{staticClass:"map-container"},[_c('gmap-map',{attrs:{"id":"map","center":_vm.center,"zoom":13,"options":{
          styles: _vm.mapStyles,
          scrollwheel: false,
          mapTypeControl: false,
          zoomControl: false,
          fullscreenControl: false,
          streetViewControl: false,
      }}},_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position,"clickable":true,"draggable":false},on:{"click":function($event){_vm.center=m.position}}})}),1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }